import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { token, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (token) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welkom terug");
      navigate("/dashboard");
    } catch {
      toast.error("Onjuiste e-mail of wachtwoord");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex flex-1 relative overflow-hidden">
        <img src="/login-hero.jpg" alt="Frankly verzorgingsproducten" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-black/10" />
        <div className="relative z-10 flex flex-col justify-between p-12 w-full">
          <div className="self-start">
            <img src="/nextproduct-wordmark.png?v=2" alt="NextProduct" className="h-7 w-auto object-contain" />
          </div>
          <div>
            <h1 className="font-display text-4xl xl:text-5xl font-medium leading-[1.15] tracking-tight text-white max-w-xl">
              "The best advertising is done by<br/>
              <span className="text-accent italic">satisfied</span> customers"
            </h1>
            <p className="mt-6 text-white/80 max-w-md">
              — Philip Kotler
            </p>
          </div>
          <div className="text-xs text-white/60">© 2026 — NextProduct</div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6 bg-background">
        <Card className="w-full max-w-md border-border shadow-none" data-testid="login-card">
          <CardHeader>
            <CardTitle className="font-display text-3xl">Inloggen</CardTitle>
            <CardDescription>Voer je gegevens in om verder te gaan.</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" type="email" data-testid="login-email" value={email}
                       onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Wachtwoord</Label>
                <Input id="password" type="password" data-testid="login-password" value={password}
                       onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
              </div>
              <Button type="submit" className="w-full h-11" data-testid="login-submit" disabled={busy}>
                {busy ? "Bezig…" : "Inloggen"}
              </Button>
              <div className="text-center">
                <Link to="/wachtwoord-vergeten" data-testid="login-wachtwoord-vergeten"
                  className="text-sm text-primary hover:underline">Wachtwoord vergeten?</Link>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
